import {useEffect, useState} from "react";

export function useDebounce<Type>(value: Type, delay: number): [Type, boolean] {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [pending, setPending] = useState(false);
  useEffect(() => {
    setPending(true);
    const handler = setTimeout(() => {
      setPending(false);
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return [debouncedValue, pending];
}
